import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const ClabeContent = styled(FlexContainer)`
  max-width: 450px;
`;
